jQuery(document).ready(function($){
	$(".faq_accordion").smk_Accordion({
		showIcon: true, //boolean
		animation: true, //boolean
		closeAble: true, //boolean
		slideSpeed: 200 //integer, miliseconds
	});

  $('a[href^="#"]').on('click', function (e) {
        e.preventDefault(); // Prevent default anchor behavior

        var target = this.hash; 
        var $target = $(target); 

        if ($target.length) {
            $('html, body').animate(
                {
                    scrollTop: $target.offset().top - 250,
                },
                800, 
                'swing'
            );
        }
    });
});
